/**
 * ローカルストレージからデータを取得する関数
 * @param {string} key キー情報
 * @returns {string}
 */
export const getStoreData = (key: string): string => {
	try {
		return localStorage.getItem(key);
	} catch (error) {
		console.warn(error);
		return undefined;
	}
};

/**
 * ローカルストレージにデータをセットする
 * @param {string} key
 * @param {string} value
 * @returns {void}
 */
export const storeData = (key: string, value: string): void => {
	try {
		localStorage.setItem(key, value);
	} catch (error) {
		console.warn(error);
	}
};
